<template>
  <v-alert
    data-testid="review-validationRequestError-alert"
    class="mt-4"
    border="left"
    colored-border
    dense
    outlined
    dismissible
    color="red"
    icon="mdi-alert-decagram"
  >
    <p class="ma-0 pr-2 body1">
      {{ text }}
    </p>
    <template v-slot:close="{ toggle }">
      <v-icon size="25" color="blue-grey" @click="close(toggle)"
        >mdi-close-circle</v-icon
      >
    </template>
  </v-alert>
</template>

<script>
export default {
  name: 'ValidationRequestErrorAlert',

  props: {
    text: {
      type: String,
    },
  },

  methods: {
    close(closeCallback) {
      this.$emit('close')
      closeCallback()
    },
  },
}
</script>
